"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _AuthDialog = _interopRequireDefault(require("./components/orgGroup/AuthDialog"));
var _AddOrEditDialog = _interopRequireDefault(require("./components/orgGroup/AddOrEditDialog"));
var _orgGroup = require("@/api/auth/orgGroup");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'orgGroupIndex',
  components: {
    SwPage: _SwPage.default,
    AuthDialog: _AuthDialog.default,
    AddOrEditDialog: _AddOrEditDialog.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      orgGroupList: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        keywords: null
      },
      authDialogData: {
        visible: false,
        currOrgGroupId: null,
        currOrgGroupName: null
      },
      addOrEditDialogData: {
        orgGroupId: null,
        status: "create",
        visible: false
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _orgGroup.queryOrgGroupList)(this.listQuery).then(function (response) {
        if (response) {
          _this.orgGroupList = response.records;
          _this.total = response.total;
        }
        setTimeout(function () {
          _this.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      //查询
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    refreshList: function refreshList() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleCreate: function handleCreate() {
      //触发添加dialog
      this.addOrEditDialogData.orgGroupId = null;
      this.addOrEditDialogData.status = 'create';
      this.addOrEditDialogData.visible = true;
    },
    handleUpdate: function handleUpdate(row) {
      //触发更新Dialog和创建的dialog共用一个dialog
      //组织组ID
      this.addOrEditDialogData.orgGroupId = row.orgGroupId;
      this.addOrEditDialogData.status = 'update';
      this.addOrEditDialogData.visible = true;
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      //删除
      this.$confirm(this.$t("prompts.wantDelRecord"), this.$t("prompts.prompts"), {
        confirmButtonText: this.$t("buttons.Confirm"),
        cancelButtonText: this.$t("buttons.Cancel"),
        type: "warning"
      }).then(function () {
        (0, _orgGroup.deleteOrgGroup)(row.orgGroupId).then(function () {
          _this2.$notify({
            title: _this2.$t("prompts.success"),
            message: _this2.$t("prompts.DeletedSuc"),
            type: 'success',
            duration: 3000
          });
          var index = _this2.list.indexOf(row);
          _this2.list.splice(index, 1);
        });
      });
    },
    handleOrgRes: function handleOrgRes(row) {
      //触发授权dialog
      this.authDialogData.visible = true;
      this.authDialogData.currOrgGroupId = row.orgGroupId;
      this.authDialogData.currOrgGroupName = row.orgGroupName;
    }
  }
};